
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plus/learnmore",
      function () {
        return require("private-next-pages/plus/learnmore/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plus/learnmore"])
      });
    }
  